const noOp = () => {};

const defaultProps = {
  aspectRatio: 'inherit',
  height: null,
  width: null,
  file: '',
  isAutoPlay: false,
  isMuted: false,
  onAdPlay: noOp,
  onAdResume: noOp,
  onEnterFullScreen: noOp,
  onExitFullScreen: noOp,
  onMute: noOp,
  onUnmute: noOp,
  onAutoStart: noOp,
  onResume: noOp,
  onPlay: noOp,
  onClose: noOp,
  onReady: noOp,
  onError: noOp,
  onAdPause: noOp,
  onPause: noOp,
  onVideoLoad: noOp,
  onOneHundredPercent: noOp,
  onThreeSeconds: noOp,
  onTenSeconds: noOp,
  onThirtySeconds: noOp,
  onSeventyFivePercent: noOp,
  onFiftyPercent: noOp,
  onTwentyFivePercent: noOp,
  onNinetyFivePercent: noOp,
  onPlayAttemptFailed: noOp,
  onPositionChange: noOp,
  playlist: [],
  gaCategory: null,
  gtmAction: null,
  gaInterval: false,
  gaElapsed: false,
  onPlayerLoaded: noOp,
  muxKey: null,
  muxPlayer: null,
  muxType: null,
  allowCast: true,
  displaytitle: false
};

export default defaultProps;
